module.exports = __webpack_public_path__ + "img/AllStop.8735d493.svg";